import '../bootstrap';
import { bindGridSwiper, userGridOptions } from './grid-swiper';

require('../css/user.css');
const InfiniteScroll = require('infinite-scroll');

function showBsModal(id) {
    const modalEl = document.getElementById(id);
    if (!modalEl) return;

    modalEl.style.display = 'block';
    modalEl.classList.add('show');
    modalEl.setAttribute('aria-hidden', 'false');
    document.body.classList.add('modal-open');

    if (!document.querySelector('.modal-backdrop')) {
        const backdrop = document.createElement('div');
        backdrop.className = 'modal-backdrop fade show';
        document.body.appendChild(backdrop);
    }
}
function hideBsModal(id) {
    const modalEl = document.getElementById(id);
    if (!modalEl) return;

    modalEl.classList.remove('show');
    modalEl.setAttribute('aria-hidden', 'true');
    modalEl.style.display = 'none';

    if (!document.querySelectorAll('.modal.show').length) {
        document.body.classList.remove('modal-open');
        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop && backdrop.parentNode) {
            backdrop.parentNode.removeChild(backdrop);
        }
    }
}

window.bindUpdateForm = function () {
    const userUpdateForm = document.getElementById('userUpdateForm');
    if (!userUpdateForm) return;

    const submitBtn = document.querySelector('.btn-do-submit');

    function doSubmit() {
        if (params.confirmed == 0) {
            showBsModal('usernameConfirmModal');
            return;
        }
        if (submitBtn) {
            submitBtn.innerHTML = '<div class="spinner-border spinner-border-sm" role="status"><span class="visually-hidden">Loading...</span></div>';
            submitBtn.setAttribute('disabled', 'disabled');
        }

        const data = new FormData(userUpdateForm);
        fetch(userUpdateForm.action, { method: userUpdateForm.method || 'POST', body: data })
            .then(r => r.json())
            .then(function (responseText) {
                if (responseText.status == 'success') {
                    window.location = responseText.data.url;
                } else {
                    if (submitBtn) {
                        submitBtn.innerHTML = 'Tiếp tục';
                        submitBtn.removeAttribute('disabled');
                    }
                    displayFormErrors(responseText.errors, userUpdateForm);
                }
            });
    }

    userUpdateForm.addEventListener('submit', function (e) {
        e.preventDefault();
        doSubmit();
    });

    ['username_username', 'username_fullname', 'username_about'].forEach(function (elId) {
        const el = document.getElementById(elId);
        if (!el) return;
        el.addEventListener('keyup', function () {
            const field = elId.split('_')[1];
            const value = el.value;
            document.querySelectorAll('.placeholder-' + field).forEach(function (p) {
                p.textContent = value;
                if (field === 'username') {
                    p.value = generateRouteUrl('orn_web_user_view', { username: value }, true);
                }
            });
        });
    });

    const confirmBtn = document.querySelector('.btn-do-confirm');
    if (confirmBtn) {
        confirmBtn.addEventListener('click', function (e) {
            e.preventDefault();
            params.confirmed = 1;
            hideBsModal('usernameConfirmModal');
            doSubmit();
        });
    }
}

window.bindFavourite = function () {
    const searchInput = document.querySelector('#searchForm input[name=s]');
    if (searchInput) {
        searchInput.addEventListener('keyup', delay(function () {
            const s = searchInput.value;
            if (s.length >= 3) {
                const listEl = document.querySelector('.dropdown-movies .list-group');
                if (listEl) listEl.innerHTML = '<div class="text-center text-muted"><div class="spinner-border spinner-border-sm" role="status"><span class="visually-hidden">Loading...</span></div></div>';

                fetch(Routing.generate('orn_web_profile_creator_favourite', { s: s, type: 'movie' }))
                    .then(r => r.json())
                    .then(function (data) {
                        let html = '';
                        data.data.forEach(function (v) {
                            html += '<a href="#" class="list-group-item px-0 btn-like-movie' + (v.liked == 1 ? ' liked' : '') + '" data-id="' + v.id + '" data-name="' + v.name + '" data-poster="' + v.poster + '" data-token="' + v.token + '"><div class="row align-items-center"><div class="col-auto"><div class="avatar"><img src="' + v.poster + '" alt="' + v.name + '" class="avatar-img rounded"></div></div><div class="col ms-n2"><h4 class="text-body mb-1">' + v.name + '</h4><p class="small text-muted mb-0">' + v.alias + '</p></div><div class="col-auto col-heart text-danger">' + (v.liked == 1 ? '<i class="icon-heart"></i>' : '') + '</div></div></a>';
                        });
                        if (listEl) listEl.innerHTML = html;
                    });
            }
        }, 1000));
    }

    document.body.addEventListener('click', function (e) {
        const btn = e.target.closest('.btn-like-movie');
        if (!btn) return;
        e.preventDefault();

        const token = btn.dataset.token;
        const id = btn.dataset.id;
        const name = btn.dataset.name;
        const poster = btn.dataset.poster;

        if (btn.classList.contains('liked')) {
            doMovieRemove(id);
        } else {
            doMovieAdd(id, name, poster, token);
        }

        fetch(Routing.generate('orn_web_movie_action', { action: 'like', id: id }), {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({ _token: token })
        }).then(r => r.json());
    });

    likes.forEach(function (v) {
        doMovieAdd(v.id, v.name, v.poster, v.token);
    });
}

window.bindInfiniteScroll = function (isAutoLoad) {
    const container = document.querySelector('.card-infinite');
    if (!container) return;

    const options = {
        path: params.url + '?page={{#}}',
        append: '.activity',
        history: false,
        status: '.page-load-status'
    };
    if (isAutoLoad == false) {
        options.button = '.btn-view-more';
        options.scrollThreshold = false;
    }

    const infScroll = new InfiniteScroll(container, options);

    infScroll.on('history', function () {
        dataLayer.push({
            'event': 'virtualPageView',
            'virtualUrl': location.pathname
        });
    });

    infScroll.on('load', function (response) {
        const text = response.body ? response.body.textContent : '';
        if (!text.trim()) {
            infScroll.destroy();
            const requestEl = document.querySelector('.page-load-status .infinite-scroll-request');
            const lastEl = document.querySelector('.page-load-status .infinite-scroll-last');
            if (requestEl) requestEl.style.display = 'none';
            if (lastEl) lastEl.style.display = '';
        }
    });
}

window.bindGridSwiper = function () {
    bindGridSwiper('.grid.swiper', userGridOptions);
};
window.bindGridSlick = window.bindGridSwiper;

window.doHandlePhoneUpdateForm = function (isModal) {
    const phoneUpdateForm = document.getElementById('phoneUpdateForm');
    if (!phoneUpdateForm) return;

    phoneUpdateForm.addEventListener('submit', function (e) {
        e.preventDefault();

        const submitBtn = phoneUpdateForm.querySelector('.btn-do-submit');
        if (submitBtn) {
            submitBtn.classList.add('disabled');
            submitBtn.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span class="visually-hidden">Loading...</span>';
        }

        const data = new FormData(phoneUpdateForm);
        fetch(phoneUpdateForm.action, { method: phoneUpdateForm.method || 'POST', body: data })
            .then(r => r.json())
            .then(function (responseText) {
                if (submitBtn) {
                    submitBtn.innerHTML = 'Gửi mã xác thực';
                    submitBtn.removeAttribute('disabled');
                    submitBtn.classList.remove('disabled');
                }

                if (responseText.status == 'success') {
                    clearFormErrors(phoneUpdateForm);

                    const phoneBtn = document.querySelector('.btn-user-phone');
                    if (phoneBtn) phoneBtn.textContent = responseText.data.phone;

                    if (isModal == true) {
                        const stepUpdate = document.getElementById('phone-step-update');
                        const stepVerify = document.getElementById('phone-step-verify');
                        if (stepUpdate) stepUpdate.style.display = 'none';
                        if (stepVerify) stepVerify.style.display = '';
                    } else {
                        showBsModal('phoneVerifyModal');
                    }
                } else {
                    displayFormErrors(responseText.errors, phoneUpdateForm);
                    if (responseText.code == 'requested') {
                        showBsModal('phoneVerifyModal');
                    }
                }
            });
    });
}

window.doHandlePhoneVerifyForm = function () {
    const phoneVerifyForm = document.getElementById('phoneVerifyForm');
    if (!phoneVerifyForm) return;

    phoneVerifyForm.addEventListener('submit', function (e) {
        e.preventDefault();

        const verifyBtn = phoneVerifyForm.querySelector('.btn-do-verify');
        if (verifyBtn) {
            verifyBtn.classList.add('disabled');
            verifyBtn.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span class="visually-hidden">Loading...</span>';
        }

        const data = new FormData(phoneVerifyForm);
        fetch(phoneVerifyForm.action, { method: phoneVerifyForm.method || 'POST', body: data })
            .then(r => r.json())
            .then(function (responseText) {
                const block = document.getElementById('phone-step-verify');

                if (responseText.status == 'success') {
                    if (block) {
                        const codeInput = block.querySelector('input[name=code]');
                        if (codeInput) codeInput.classList.remove('is-invalid');
                        block.querySelectorAll('.invalid-feedback').forEach(function (el) {
                            el.classList.add('d-none');
                            el.classList.remove('d-block');
                        });
                        const errorMsg = block.querySelector('.form-error-message');
                        if (errorMsg) errorMsg.textContent = '';
                    }

                    hideBsModal('phoneVerifyModal');
                    window.location.reload();
                } else {
                    if (verifyBtn) {
                        verifyBtn.classList.remove('disabled');
                        verifyBtn.textContent = 'Xác thực';
                    }
                    if (block) {
                        const codeInput = block.querySelector('input[name=code]');
                        if (codeInput) codeInput.classList.add('is-invalid');
                        block.querySelectorAll('.invalid-feedback').forEach(function (el) {
                            el.classList.add('d-block');
                            el.classList.remove('d-none');
                        });
                        const errorMsg = block.querySelector('.form-error-message');
                        if (errorMsg) errorMsg.textContent = responseText.msg;
                    }
                }
            });
    });
}

window.bindAvatarForm = function () {
    document.querySelectorAll('.btn-avatar-update').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            document.getElementById('user_avatar_file').click();
        });
    });

    document.querySelectorAll('.btn-cover-update').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            document.getElementById('user_cover_fileCover').click();
        });
    });

    const avatarInput = document.getElementById('user_avatar_file');
    if (avatarInput) {
        avatarInput.addEventListener('change', function () {
            const avatarForm = document.getElementById('userAvatarForm');
            if (!avatarForm) return;

            const btn = document.querySelector('.btn-avatar-update');
            if (btn) {
                btn.innerHTML = '<div class="spinner-border spinner-border-sm" role="status"><span class="visually-hidden">Loading...</span></div>';
                btn.classList.add('disabled');
            }

            const data = new FormData(avatarForm);
            fetch(avatarForm.action, { method: avatarForm.method || 'POST', body: data })
                .then(r => r.json())
                .then(function (responseText) {
                    if (btn) {
                        btn.innerHTML = '<i class="fe fe-camera"></i>';
                        btn.classList.remove('disabled');
                    }
                    if (responseText.status == 'success') {
                        handleUploadSuccess(responseText.data);
                    } else {
                        handleUploadErrors(responseText.errors);
                    }
                });
        });
    }

    const coverInput = document.getElementById('user_cover_fileCover');
    if (coverInput) {
        coverInput.addEventListener('change', function () {
            const coverForm = document.getElementById('userCoverForm');
            if (!coverForm) return;

            const btn = document.querySelector('.btn-cover-update');
            if (btn) {
                btn.innerHTML = '<div class="spinner-border spinner-border-sm" role="status"><span class="visually-hidden">Loading...</span></div>';
                btn.classList.add('disabled');
            }

            const data = new FormData(coverForm);
            fetch(coverForm.action, { method: coverForm.method || 'POST', body: data })
                .then(r => r.json())
                .then(function (responseText) {
                    if (btn) {
                        btn.innerHTML = '<i class="fe fe-camera"></i> Cập nhật ảnh bìa';
                        btn.classList.remove('disabled');
                    }
                    if (responseText.status == 'success') {
                        handleUploadSuccess(responseText.data);
                    } else {
                        handleUploadErrors(responseText.errors);
                    }
                });
        });
    }
}

function doMovieAdd(id, name, poster, token) {
    const html = '<div id="movie-' + id + '" class="col-lg-2 col-sm-3 col-4 item btn-like-movie liked" data-id="' + id + '" data-token="' + token + '"><div class="mb-4"><a href="#" title="' + name + '" class="position-relative d-block"><i class="fe fe-x remove-icon"></i><img alt="' + name + '" src="' + poster + '" class="img-fluid rounded border"></a></div></div>';

    document.querySelectorAll('.btn-like-movie[data-id="' + id + '"] .col-heart').forEach(function (el) { el.innerHTML = '<i class="icon-heart"></i>'; });
    document.querySelectorAll('.btn-like-movie[data-id="' + id + '"]').forEach(function (el) { el.classList.add('liked'); });

    const moviesEl = document.getElementById('movies');
    if (moviesEl) moviesEl.insertAdjacentHTML('afterbegin', html);
    doDetectButtonText();
}

function doMovieRemove(id) {
    const movieEl = document.getElementById('movie-' + id);
    if (movieEl) movieEl.remove();
    document.querySelectorAll('.btn-like-movie[data-id="' + id + '"] .col-heart').forEach(function (el) { el.innerHTML = ''; });
    document.querySelectorAll('.btn-like-movie[data-id="' + id + '"]').forEach(function (el) { el.classList.remove('liked'); });
    doDetectButtonText();
}

function doDetectButtonText() {
    const continueBtn = document.querySelector('.btn-do-continue');
    if (!continueBtn) return;
    continueBtn.textContent = document.querySelectorAll('#movies .item').length == 0 ? 'Bỏ qua' : 'Hoàn thành';
}

function handleUploadSuccess(data) {
    const continueBtn = document.querySelector('.btn-do-continue');
    if (continueBtn) continueBtn.textContent = 'Tiếp tục';

    const formErrors = document.querySelector('.form-errors');
    if (formErrors) formErrors.innerHTML = '';

    const avatarEl = document.getElementById('placeholder-avatar');
    if (avatarEl) avatarEl.setAttribute('src', data.avatar);

    const coverEl = document.getElementById('placeholder-cover');
    if (coverEl) coverEl.setAttribute('src', data.cover);
}

function handleUploadErrors(errors) {
    let errorsHtml = '';
    for (const key in errors.fields) {
        errorsHtml += '<p class="invalid-feedback mb-0 d-block"><i class="fe fe-alert-circle"></i> ' + errors.fields[key] + '</p>';
    }

    const formErrors = document.querySelector('.form-errors');
    if (formErrors) formErrors.innerHTML = errorsHtml;
}
